<h3>Reports Ready to Submit @if (count > 0) {<span>{{count}}</span>}</h3>
@if (!isLoading) {
    <div class="incomplete">
        @if (!noData) {
            <table class="table table-striped table-fixed">
                <tbody>
                    @for (a of applicants; track a) {
                        <tr class="applicant" (click)="openApplicant(a)">
                            <td class="appname">
                                <span class="profile-image">
                                    <app-cf-profile [urlOrInitials]="a.profile"
                                        [width]="30" [height]="30"></app-cf-profile>
                                </span>
                                @if (a.status > 0) {
                                    <span container="body" ngbPopover="{{a.statusInfo}}"
                                        popoverClass="slot-popover" triggers="mouseenter:mouseleave" popoverTitle="Note"><i
                                            class="warning fa-solid fa-circle-exclamation"></i></span>
                                }
                                {{a.name}}
                            </td>
                            @if (showInterviewer) {
                                <td class="interviewer">{{a.interviewerName}}</td>
                            }
                            <td class="date">{{a.date}}</td>
                            <td class="state">{{a.userState}}</td>
                        </tr>
                    }
                </tbody>
            </table>
        }
        @if (noData) {
            <div>
                <p>No interview reports ready to submit.</p>
            </div>
        }
    </div>
} @else {
    <div class="loading">
        <app-cf-loader></app-cf-loader>
    </div>
}